import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: { auth: true },
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/subscriptions',
        name: 'Subskrypcje',
        meta: { auth: true },
        component: () => import('@/views/Subscriptions.vue'),
      },
      {
        path: '/subscriptions/:id',
        name: 'Edycja subskrypcji',
        meta: { auth: true },
        component: () => import('@/views/SubscriptionsEdit.vue'),
      },
      {
        path: '/sentiments',
        name: 'Sentymenty',
        meta: { auth: true },
        component: () => import('@/views/Sentiments.vue'),
      },
      {
        path: '/sentiments/:id',
        name: 'Edycja sentymentu',
        meta: { auth: true },
        component: () => import('@/views/SentimentsEdit.vue'),
      },
      {
        path: '/users',
        name: 'Użytkownicy',
        meta: { auth: true },
        component: () => import('@/views/Users.vue'),
      },
      {
        path: '/payments',
        name: 'Płatności',
        meta: { auth: true },
        component: () => import('@/views/Payments.vue'),
      },
      {
        path: '/orders',
        name: 'Zamóienia',
        meta: { auth: true },
        component: () => import('@/views/Orders.vue'),
      },
    ],
  },
  {
    path: '/error',
    redirect: '/error/404',
    name: 'Errors',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
    ],
  },
  {
    path: '/auth',
    redirect: '/error/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        meta: { guest: true },
        component: () => import('@/views/pages/Login'),
      },
    ],
  },
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    if (store.getters.isAuthenticated) {
      next()

      return
    } else {
      store.dispatch('user').then(() => {
        if (!store.getters.isAuthenticated) {
          next('/auth/login')
        } else {
          next()
        }
      })
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/dashboard')

      return
    }

    next()
  } else {
    next()
  }
})

export default router
